/*
 * @Author: Ryan
 * @Date: 2025-12-29
 * @Description: Start button component with gradient style for AI Voice Cloning
 */
import { Button, ButtonProps } from 'antd';
import React from 'react';

import { scrollToTop } from '@/utils/landing/scrollToTop';

export interface StartButtonProps extends Omit<ButtonProps, 'onClick'> {
  /**
   * 按钮文本
   */
  text?: string;
  /**
   * 自定义点击处理函数，如果提供则覆盖默认的滚动到顶部行为
   */
  onClick?: (e: React.MouseEvent<HTMLElement>) => void;
}

const StartButton: React.FC<StartButtonProps> = ({
  text = 'Clone Your Voice Now',
  onClick,
  className,
  style,
  ...restProps
}) => {
  const handleClick = (e: React.MouseEvent<HTMLElement>) => {
    if (onClick) {
      onClick(e);
    } else {
      scrollToTop();
    }
  };

  return (
    <>
      <Button
        type="primary"
        size="large"
        onClick={handleClick}
        className={`seo-gradient-btn ${className || ''}`}
        style={{
          border: 'none',
          borderRadius: '8px',
          height: '52px',
          padding: '0 32px',
          fontSize: '16px',
          fontWeight: 500,
          ...style,
        }}
        {...restProps}
      >
        {text}
      </Button>
      <style jsx global>{`
        .seo-gradient-btn.ant-btn {
          background: linear-gradient(90deg, #4d2fff 0%, #ef5cff 100%) !important;
          transition: all 0.3s ease;
        }
        .seo-gradient-btn.ant-btn:hover {
          background: linear-gradient(
            90deg,
            rgba(77, 47, 255, 0.6) 0%,
            rgba(239, 92, 255, 0.6) 100%
          ) !important;
        }
        .seo-gradient-btn.ant-btn:active {
          background: linear-gradient(90deg, #4d2fff 0%, #ef5cff 100%) !important;
        }
      `}</style>
    </>
  );
};

export default StartButton;
